import { createSlice } from '@reduxjs/toolkit'

/**
 * Redux slice, que maneja las acciones que modifican
 * el estado de las paginas de la aplicación.
 */
const pagesSlice = createSlice({
  name: 'pages',
  initialState: {
    cargaInicial: false,
    paginas: [],
    paginaSeleccionada: {}
  },
  reducers: {
    /**
     * Acción que establece la lista de todas las paginas de la aplicación.
     * @param {Object} state - Estado actual del slice.
     * @param {Array} payload - Payload que contiene la información de todas las paginas.
     */
    getPages: (state, { payload }) => {
      if (!state.cargaInicial) {
        state.paginas = payload
        state.cargaInicial = true
      }
    },

    /**
     * Acción que establece una pagina seleccionada en el estado.
     * @param {Object} state - Estado actual del slice.
     * @param {Object} payload - Payload con la información de la pagina seleccionada.
     */
    getPageByURL: (state, { payload }) => {
      state.paginaSeleccionada = payload
    },

    /**
     * Acción que añade una nueva página al estado.
     * @param {Object} state - Estado actual del slice.
     * @param {Object} payload - Payload con la información de la página a actualizar.
     */
    createPage: (state, { payload }) => {
      if (state.cargaInicial) {
        state.paginas.unshift(payload)
      }
    },

    /**
     * Acción que actualiza la página seleccionada en el estado.
     * @param {Object} state - Estado actual del slice.
     * @param {Object} payload - Payload con la información de la página a actualizar.
     */
    updatePage: (state, { payload }) => {
      state.paginaSeleccionada = payload
      if (state.cargaInicial) {
        const index = state.paginas.findIndex((pagina) => pagina.id === payload.id)
        state.paginas[index] = payload
      }
    },

    /**
     * Acción que elimina una página del estado.
     * @param {Object} state - Estado actual del slice.
     * @param {Object} payload - Payload con la información de la página a eliminar.
     */
    deletePage: (state, { payload }) => {
      if (state.cargaInicial) {
        const index = state.paginas.findIndex((pagina) => pagina.id === payload.id)
        state.paginas.splice(index, 1)
      }
    }
  }
})

export const { getPages, getPageByURL, createPage, updatePage, deletePage } = pagesSlice.actions
export default pagesSlice.reducer
